module.exports = __webpack_public_path__ + "static/media/twitter.88827a6a.png";